import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
function RulesRegulation() {
  useEffect(() => {
    document.title =
      "Rules & Regulation -  St Peters convent School Faridabad Haryana";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li>About Us </li>
          <li>Rules & Regulation </li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Rules & Regulation </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <h3>
                <b>Admission to KG</b>
              </h3>
              <ul className="list">
                <li>
                  {" "}
                  Age for admission to Nursery should be 3 years as on 31st
                  March.{" "}
                </li>
                <li>Admission to other classes against vacancies only. </li>
                <li>
                  {" "}
                  Information for admission to other classes can be sought from
                  school office in the Second week of October.{" "}
                </li>
                <li> No capitation fees is charged. </li>
                <li>
                  Process of admission can commence either online or offline
                  form first week of October.{" "}
                </li>
                <li>
                  {" "}
                  Details for online mode are available on
                  http://spcsfbd.ac.in{" "}
                </li>
                <li>
                  {" "}
                  Offers of donations / gifts etc. will lead to disqualification
                  of the candidates.{" "}
                </li>
              </ul>

              <h3>
                <b>Mandatory Documents For Admission</b>
              </h3>
              <ul className="list">
                <li>Registration form</li>
                <li> Valid Aadhaar Card of Child and both parents.</li>
                <li>
                  Parivar Pehchan Patra (Family ID), if residents of Haryana.
                </li>
                <li> Birth Certificate issued by Corporation or Panchayat.</li>
                <li>Original Transfer Certificate of previous school.</li>
              </ul>

              <h3>
                <b>School Fees</b>
              </h3>
              <ul className="list">
                <li>
                  {" "}
                  The fees are charged for twelve months of the year and are to
                  be paid quarterly. The quarterly fee will be collected in
                  advance. It is to be paid quarterly in the months of April,
                  July, October and January.
                </li>
                <li>
                  {" "}
                  Fees should be deposited on or before 20th of the first month
                  of the quarter. Deposition of fees after the prescribed date
                  will entail a late fee of Rs. 50 per month.
                </li>
                <li>
                  {" "}
                  The parents will kindly keep the pay-in-slip counter foils
                  with them at least for two years and produce them whenever
                  required by the school for checking, if necessary.
                </li>
                <li>
                  The rate of fees is subject to change from time to time due to
                  the increasing cost of teacher's salary, maintenance and other
                  expenses.
                </li>
                <li>
                  {" "}
                  Fee defaulters are ineligible to sit for the final examination
                  and for promotion. Lapse in payment of fees on time will
                  entail removal from roll. A student will be re admitted and
                  re-admission fees will be levied. Fees once paid will be not
                  be refunded.
                </li>
                <li>
                  {" "}
                  Fees will be deposited in the South Indian Bank, SLF Mall, IP
                  Colony, Faridabad; drawn in favour of St. Peter's Convent
                  Kindergarten- (Nursery, LKG, UKG), and St. Peter's Convent
                  School (I to X).
                </li>
              </ul>

              <h3>
                <b>Promotion Criteria</b>
              </h3>
              <ul className="list">
                <li>
                  {" "}
                  To get promoted to the next class 25% marks in written exams
                  with 75% of attendance is compulsory.
                </li>
                <li>
                  {" "}
                  Attending all the examinations is compulsory for promotions. A
                  medical certificate should be submitted in case of absence due
                  to sickness.
                </li>
                <li>
                  {" "}
                  No retest will be conducted for absentees. In such case
                  promotion to the next class will be purely based on the
                  performance in the previous examinations. Such students will
                  not be considered eligible for the proficiency award.
                </li>
              </ul>

              <h3>
                <b>Withdrawal</b>
              </h3>
              <ul className="list">
                <li>
                  One clear calendar month's notice in writing or a month's fees
                  in lieu of such notice must be given before a pupil is
                  withdrawn.
                </li>
                <li>
                  {" "}
                  Transfer certificate will not be issued until all school dues
                  are cleared.
                </li>
                <li>
                  {" "}
                  Those who leave the school in May, must, in all cases pay the
                  fee for the month of June.
                </li>
                <li>
                  {" "}
                  If a student admitted, has to be withdrawn from the school in
                  the middle of a term. Tuition fee for the whole term is to be
                  paid.
                </li>
              </ul>

              <h3>
                <b>Fee Concession Policy</b>
              </h3>
              <ul className="list">
                <li>
                  Fee concession will be granted to students without
                  discrimination on the basis of caste, creed, or religion.
                  However, priority will be given to students from minority
                  sections.
                </li>
                <li>
                  Students belonging to economically weaker sections must submit
                  officially valid supporting documents.
                </li>
                <li>
                  {" "}
                  Students may apply for concession if he/she has lost both
                  parents or if the sole earning parent/guardian is suffering
                  from a long-term or chronic illness, supported by relevant
                  medical documents.
                </li>
                <li>
                  {" "}
                  To be considered for fee concession, the student must have
                  been studying in the school for at least two consecutive
                  academic years. Kindergarten students are not eligible.
                  Concession may also be considered for students whose families
                  are known to or associated with the school management or
                  staff.
                </li>
                <li>
                  {" "}
                  Applicants seeking fee concession must have obtained a minimum
                  of 60% aggregate marks in the previous academic year and the
                  concession is subject to verification, recommendation, and
                  approval by the school authorities.
                </li>
                <li>
                  {" "}
                  Final approval for granting any fee concession rests solely
                  with the school management.
                </li>
                <li>
                  {" "}
                  A written application, along with the school-issued form and
                  relevant supporting documents, must be submitted by 15th May
                  to substantiate the claim . Applications received after this
                  date will not be considered.
                </li>
              </ul>

              <h3>
                <b>Visiting Time for Parents</b>
              </h3>
              <ul className="list">
                <li>
                  {" "}
                  Parent-Teacher Meetings (PTMs) are organized to maintain a
                  close rapport between parents and teachers.
                </li>
                <li>
                  {" "}
                  In case you need to meet any teacher, Vice Principal or
                  Principal outside PTM Schedule you are requested to take prior
                  appointment.
                </li>
              </ul>
              <h3>
                <b>To The Parents</b>
              </h3>
              <ul className="list">
                <li>
                  {" "}
                  Acknowledge the receipt of all circulars and test records.
                </li>
                <li>
                  Label all the books (outside & inside) & other belongings like
                  water bottles, lunch box, bag etc.
                </li>
                <li>
                  {" "}
                  Name slip should be pinned to the shirt till the children get
                  identity card (ID) prepared by the school.
                </li>
                <li>
                  {" "}
                  Once the student gets the school diary, he / she is supposed
                  to bring it daily and fill the personal record column on pg 1
                  to 5. The parents are requested to check the diary and go
                  through the circulars issued by the school time to time.
                </li>
                <li>
                  {" "}
                  Leave letters are to be submitted to the class teacher well in
                  advance in case of leave.
                </li>
                <li>
                  {" "}
                  In case of sick leave the original Medical Certificate should
                  be submitted.
                </li>
                <li>
                  Please send a small towel along with the child for lunch time
                  and a face handkerchief with the child every day.
                </li>
                <li>
                  Class work and home work are to be done in the same book.
                </li>
                <li>
                  {" "}
                  The children are encouraged to do their home work by
                  themselves.
                </li>
                <li>
                  Use four-line notebook for English.(Not applicable for classes
                  3rd – 8th )
                </li>
                <li>
                  {" "}
                  Use Five line notebook for Hindi.(Not applicable for classes
                  3rd – 8th )
                </li>
                <li>
                  Use square box notebook for Mathematics work .(Not applicable
                  for classes 3rd – 8th )
                </li>
                <li>
                  {" "}
                  Separate note books should be used for holiday homework and
                  class tests.
                </li>
                <li>
                  {" "}
                  Please see that the children come to school neat and tidy.
                </li>
                <li>
                  {" "}
                  Syllabus, diary, ID card etc. shall be provided in due time.
                </li>
                <li>
                  {" "}
                  Parents can meet the Principal between 10.00 a.m. to 11.00
                  a.m.
                </li>
                <li>
                  {" "}
                  Only the parents are allowed to take their wards during the
                  school hours with the permission of Principal.
                </li>

                <li>
                  {" "}
                  Parents are allowed to meet the teachers on Parent – Teacher
                  meeting days only.
                </li>
                <li>
                  {" "}
                  Children should bring their lunch with them and bringing lunch
                  by the parents during lunch break is not encouraged.
                </li>
                <li>
                  {" "}
                  There will be a fine for applying nail polish, Mahendi, Kajal
                  and other accessories (i.e. bangles, ring, and earrings) ,
                  speaking in Hindi ,late coming and improper uniform.
                </li>
                <li> Full attendance will be rewarded.</li>
                <li>
                  {" "}
                  Irregular attendance, habitual idleness, neglect of home work,
                  disobedience and disrespect towards the staff or bad moral
                  influence will lead to dismissal.
                </li>
              </ul>

              <h3>
                <b>School Uniform</b>
              </h3>
              <ul className="list">
                <li>
                  {" "}
                  All the students must come to school neat and tidy in proper
                  uniform.
                </li>
                <li>
                  Visit the School website for uniform details.
                  http://spcsfbd.ac.in
                </li>
                <li>
                  {" "}
                  Only the prescribed uniform pattern and color code are
                  allowed.
                </li>
                <li>
                  {" "}
                  The school's official logo must be present on the uniform.
                </li>
                <li>
                  {" "}
                  No modifications or alterations to the uniform are permitted.
                </li>
                <li> Uniforms must be clean, neat, and well-maintained.</li>
                <li>
                  Approved footwear and accessories must be worn as per school
                  guidelines.
                </li>
                <li>
                  Yearly approval from the school principal is required for any
                  exceptions or alterations.
                </li>
                <li> Fancy hair styles are not permitted.</li>
                <li>
                  Girls with hair longer than shoulder length must tie it into
                  two braids
                </li>
                <li>
                  {" "}
                  Students who are not in full uniform and fail to provide a
                  note may receive a behavior notification
                </li>
                <li>
                  The school identity card is mandatory for all students during
                  school hours.
                </li>
                <li>
                  {" "}
                  Bracelets and bangles are not allowed in school for safety
                  reasons.
                </li>
              </ul>

              <h3>
                <b>Birthday Celebration</b>
              </h3>
              <ul className="list">
                <li>
                  The students up to Class V only are allowed to wear a casual
                  dress on their birthday.
                </li>
                <li>
                  They may share a packet of toffees with their classmates, and
                  teachers or they can contribute an amount of money to the
                  school's poor fund.
                </li>
              </ul>

              <h3>
                <b>Regularity</b>
              </h3>
              <ul className="list">
                <li>
                  The students must reach the school at least five minutes
                  before the time fixed for the reporting time. (see page no. 9
                  for School Hours).
                </li>
                <li>
                  No one should leave the school premises during school hours
                  without the Principal's permission.
                </li>
                <li>
                  Withdrawal of the child from the school for social functions
                  or ordinary medical reasons is not encouraged.
                </li>
                <li>
                  {" "}
                  Students who are not present at the designated reporting time
                  will be treated as latecomers.
                </li>
                <li>
                  {" "}
                  Students who are late more than three times will receive a
                  behavioral notification and will be allowed to sit in class
                  only after parental consent.
                </li>
              </ul>

              <h3>
                <b>Attendance</b>
              </h3>
              <ul className="list">
                <li>
                  whenever there is a school function. 1. The students are not
                  allowed to be absent on the closing day/reopening day or
                </li>
                <li>
                  {" "}
                  Irregular attendance, habitual idleness, negligence of
                  homework, disobedience or disrespect towards the members of
                  the staff or bad moral influence will lead to dismissal.
                </li>
                <li>
                  If a student is absent, a leave note of absence is required.
                  All applications for leave must be made through the pages of
                  his handbook.
                </li>
                <li>
                  Leave without prior sanction from the principal may be treated
                  as an absence if no information is given for one month the
                  pupil's name will be struck off the roll.
                </li>
                <li>
                  {" "}
                  Absence on account of illness should be supported by a medical
                  certificate. No leave of absence will be granted except in an
                  exigency.
                </li>
                <li>
                  {" "}
                  Absence without leave is liable to be compensated at the
                  Principal's discretion.
                </li>
                <li> For promotion, 75% of attendance is mandatory.</li>
              </ul>

              <h3>
                <b>School Transport</b>
              </h3>
              <ul className="list">
                <li>
                  Bus facility has been provided for the convenience of parents
                  and students, who requested to follow the regulations
                  stipulated below.
                </li>
                <li>
                  {" "}
                  No child will be permitted to discontinue bus service in the
                  middle of the year.
                </li>
                <li>
                  All bus commuters are expected to be at the bus stop at least
                  five minutes before the arrival of the bus.
                </li>
                <li>The bus will not wait for late comers.</li>
                <li>
                  {" "}
                  Children should stay away from the main road until the bus
                  arrives.
                </li>
                <li>
                  {" "}
                  No student should come near the entry door of the bus until it
                  has made a complete stop.
                </li>
                <li>
                  {" "}
                  The front door of the bus is the only authorised entrance and
                  exit.
                </li>
                <li>
                  {" "}
                  The list of stops is prepared keeping in view for the
                  convenience and safety of all bus commuters and it is always
                  subject to change.
                </li>
                <li>
                  When the bus is in motion students must not move in the bus
                  and not expose their heads or arms outside the window.
                </li>
                <li>
                  {" "}
                  No student is allowed to eat in the bus and should not throw
                  anything inside or outside the bus.
                </li>
                <li>
                  In case of any seat/seat cover etc. is torn or damaged, the
                  cost will be recovered from the defaulter.
                </li>
                <li>
                  {" "}
                  Shouting is prohibited in the bus. Courteous behaviour is
                  expected at all times.
                </li>
                <li>
                  The teachers and bus monitors are responsible for maintaining
                  discipline in the buses. Any serious offence must be reported
                  to the Principal.
                </li>
                <li>
                  {" "}
                  The driver's attention must not be distracted for any reason.
                </li>
                <li>
                  {" "}
                  Students must travel only by the buses allotted to them.
                </li>
              </ul>

              <h3>
                <b>School Library</b>
              </h3>
              <ul className="list">
                <li>
                  Books are issued for two weeks only. If a child fails to
                  return the book on time, fine will be charged for the same.
                </li>
                <li>
                  {" "}
                  The readers shall not sub-lend the books issued by the
                  library.
                </li>
                <li>
                  {" "}
                  Books marked, disfigured, damaged or misplaced will have to be
                  replaced or paid for by the borrower.
                </li>
                <li>
                  {" "}
                  Children should maintain a diary for library notes that will
                  help them to improve their vocabulary and language skills.
                </li>
                <li>
                  Children should follow all library rules and maintain silence
                  in the library.
                </li>
              </ul>

              <h3>
                <b>Use of Washrooms</b>
              </h3>
              <ul className="list">
                <li>
                  1. Generally, only one student at a time may be permitted to
                  use the washroom during class hours with the teacher's
                  approval.
                </li>
                <li>
                  {" "}
                  Students requiring frequent washroom use must provide written
                  consent to the Class teacher.
                </li>
                <li>
                  {" "}
                  A pass card is mandatory for students to leave the classroom
                  during class hours
                </li>
              </ul>

              <h3>Counselling and Guidance</h3>
              <ul className="list">
                <li>
                  The school Counsellor and Guidance teachers are available to
                  support all student
                </li>
                <li>
                  {" "}
                  These services are meant to assist students, and parents can
                  be assured that their ward's well-being is a priority.
                </li>
                <li>
                  Staff may refer students with repeated misbehavior to the
                  Guidance teacher for support.
                </li>
                <li>
                  Teachers can refer students needing additional help to the
                  Guidance team.
                </li>
                <li>
                  Students can request a Counsellor appointment through their
                  Class teacher.
                </li>
                <li>
                  {" "}
                  Students must remember their appointment dates and reschedule
                  if missed.
                </li>
                <li>
                  {" "}
                  Before a session, students must inform teachers of any missed
                  lessons for excusal.
                </li>
              </ul>

              <h3>
                <b>Personal Belongings</b>
              </h3>
              <ul className="list">
                <li>
                  The school is not responsible for lost items; students are
                  advised not to bring valuables or expensive gadgets.
                </li>
                <li>
                  {" "}
                  Students must take responsibility for their own books and
                  personal belongings.
                </li>
                <li>
                  Damaging others' belongings will result in disciplinary action
                  and a behavioral notification.
                </li>
              </ul>

              <h3>
                <b>Damage to the School property</b>
              </h3>
              <ul className="list">
                <li>
                  {" "}
                  Students are strictly forbidden to write or scribble on walls,
                  desks, benches etc., or throw paper or spill ink around the
                  classrooms or cause damage to the school property such as
                  laboratory articles, library books, furniture etc.
                </li>
                <li>
                  {" "}
                  Damage done to the school property should be compensated for
                  any such cases will be dealt strictly.
                </li>
                <li>
                  {" "}
                  The school authorities will be constrained to resort to stern
                  actions to curb all kinds of destructive tendencies in the
                  students.
                </li>
              </ul>

              <h3>
                <b>School Medical Room Rules</b>
              </h3>
              <ul className="list">
                <li>
                  To visit the Medical room, get permission from the class
                  teacher, except in emergencies.
                </li>
                <li>
                  {" "}
                  Sign in and out in the School Diary and medical room register.
                </li>
                <li> Serious cases will be treated first.</li>
                <li> Keep quiet and avoid crowding.</li>
                <li> No eating or drinking inside.</li>
                <li>
                  {" "}
                  The medical room is for temporary relief. Parents will be
                  contacted if a student remains unwell.
                </li>
                <li>
                  {" "}
                  Inform the medical staff if you are already on any medication.
                </li>
              </ul>

              <h3>
                <b>Microsoft Teams</b>
              </h3>
              <ul className="list">
                <li>
                  {" "}
                  Microsoft Teams, an online platform, is accessible to our
                  students and as well as our teachers.
                </li>
                <li> This platform is used to conduct on-line classes.</li>
                <li>
                  {" "}
                  Teachers can utilize this platform to create and share
                  assignments, as well as other resources, to enhance the
                  effectiveness of online learning.
                </li>
                <li>
                  Parents can also communicate with teachers through this app,
                  to foster a collaborative relationship between home and
                  school.
                </li>
                <li>
                  {" "}
                  To prevent malpractice, keep your credentials safe and
                  private, as sharing passwords may lead to unauthorized access.
                </li>
              </ul>

              <h3>
                <b>Celebration</b>
              </h3>
              <ul className="list">
                <li>
                  {" "}
                  Promote Peace & Harmony - Celebrations must encourage unity
                  and inclusivity, without caste or religious
                  discrimination.{" "}
                </li>
                <li>
                  {" "}
                  Eco-Friendly - Crackers, party poppers, color splashes, and
                  any polluting materials are strictly prohibited.{" "}
                </li>
                <li>
                  {" "}
                  Respect School Property - No damage to school property;
                  vandalism of any kindis not allowed.{" "}
                </li>
                <li>
                  No Wall Pasting - Posters, stickers, or decorations should not
                  be pasted on school walls or doors.{" "}
                </li>
              </ul>

              <h3>
                <b>General Behaviour</b>
              </h3>
              <ul className="list">
                <li>
                  {" "}
                  The students are strictly forbidden from bringing crackers or
                  any sort of firearms to school. Serious action to the nature
                  of dismissal may be taken if found in possession of the same.
                </li>
                <li>
                  Students found tampering with the school records e.g. marks
                  allotted by teachers in tests/exams are liable to strict
                  disciplinary action.
                </li>
                <li>
                  {" "}
                  Students should refrain from having Facebook, Instagram or
                  other social networking accounts, as these may be misused.
                </li>
                <li>
                  {" "}
                  The report card being an important document should be kept
                  safely. In case it is spoilt or lost, the students shall get a
                  duplicate report card on a chargeable basis.
                </li>
                <li>
                  {" "}
                  Students should observe polite standards wherever they go.
                  They should always remember that the school is judged by their
                  behaviour. Bullying in any form- direct, indirect, cyber
                  bullying, casteism or using foul language are punishable
                  offences and may even merit expulsion from school. They should
                  not indulge in any anti-social activity in or outside the
                  school, failing which the school may take disciplinary action.
                </li>
                <li>
                  Movement for activities and at dispersal should be done in
                  silence and in orderly fashion.
                </li>
                <li>
                  {" "}
                  No books (other than text books or library books), magazines,
                  pen drives, cassettes or Cds should be brought to school
                  without the principal's permission.
                </li>
                <li>
                  {" "}
                  Students must strictly refrain from smoking, gambling, use of
                  drugs or intoxicants or use of violence in any form.
                </li>
                <li>
                  Two-wheelers (except bicycles) are not permitted; if brought,
                  they will be taken into school custody, and disciplinary
                  action will follow.
                </li>
              </ul>

              <h3>
                <b>Don'ts</b>
              </h3>
              <p>
                <i>
                  No student shall indulge in any of the following practices: -
                </i>
              </p>
              <ul className="list">
                <li>Damaging or spoiling the belongings of others</li>
                <li> Spitting, Smoking, Bunking, Vandalism</li>
                <li>
                  {" "}
                  Crackers, party poppers, colour splashes, and any polluting
                  materials
                </li>
                <li> Rowdyism and rude behaviour</li>
                <li> Casteism, communalism or practice of untouchability </li>
                <li> Disfiguring and damaging of school property</li>
                <li> Scribbling on the furniture and the walls</li>
                <li>Prohibited from riding motorized vehicles</li>
              </ul>

              <p>
                <b>
                  The observance of rules of discipline of the school and good
                  behaviour is essential to a student's continuance in the
                  school. In case any student violates the school rules or
                  indulges in any form of indiscipline, strict action like
                  expulsion/suspension/rustication shall be taken against the
                  student. If a student gets suspended two times and school
                  authorities consider it necessary to suspend him/her for the
                  third time, he/she will be rusticated.
                </b>
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default RulesRegulation;
